// @ts-check
import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import api from 'modules/queries/api';
import { useOidcSilent } from './silentProvider';
import useAuthenticated from './useAuthenticated';
import useLogin from './useLogin';

export function ApiUnauthorizedConnector() {
	const { activeNavigator } = useAuth();
	const isAuthenticated = useAuthenticated();
	const [, silentRefresh] = useOidcSilent();
	const login = useLogin();

	const isReadyRef = useRef(!activeNavigator);
	isReadyRef.current = !activeNavigator;

	// handle 401 errors
	useEffect(() => {
		const controller = new AbortController();
		if (!isAuthenticated) return undefined;

		/** @type {import('club-sauce/api').LWApiBaseEventsI['error']} */
		const handleError = (event) => {
			const { status } = event;

			if (!isReadyRef.current || status !== 401) return;
			silentRefresh({ signal: controller.signal })
				.catch(() => null)
				.then((user) => {
					if (controller.signal.aborted || user) return;
					// Start over since we're invalid now
					login();
				});
		};

		api.on('error', handleError);

		return () => {
			controller.abort();
			api.off('error', handleError);
		};
	}, [isAuthenticated, login, silentRefresh]);

	return null;
}

export default ApiUnauthorizedConnector;
